<fuse-card class="flex h-full flex-col">
  <div class="flex items-center gap-2 border-b px-4 py-3">
    <span class="flex-1 text-sm font-semibold text-gray-900">System Activity</span>
    <a
      routerLink="/profile/activity-logs"
      [queryParams]="{ _ref: 'dashboard' }"
      class="rounded border border-transparent px-2 py-0.5 text-xs text-gray-400 transition hover:border-gray-200 hover:text-primary"
      >View all</a
    >
  </div>
  <div class="flex-1 overflow-y-auto">
    @if (dataLoader) {
      <div class="flex justify-center p-6">
        <mat-spinner diameter="28" color="primary"></mat-spinner>
      </div>
    }
    @if (dataList?.length && !dataLoader) {
      @for (item of dataList; track item.id) {
        <div class="flex items-start gap-3 border-b px-4 py-2.5 last:border-b-0">
          <img [src]="item.causer?.profile_image_url | avatar: item.causer?.full_name" class="h-7 w-7 shrink-0 rounded-lg border border-gray-100 object-cover" alt="" />
          <div class="min-w-0 flex-1 text-xs leading-snug">
            <span class="font-semibold text-gray-900">{{ item.causer?.first_name }}</span>
            <span class="text-gray-500" [innerHTML]="' ' + item.description"></span>
          </div>
          <span class="shrink-0 whitespace-nowrap text-xs text-gray-400">{{ item.created_at | date: 'shortTime' }}</span>
        </div>
      }
    }
    @if (!dataLoader && !dataList?.length && !error) {
      <div class="flex flex-col items-center justify-center gap-2 py-8 text-gray-400">
        <mat-icon fontIcon="history" class="opacity-40 icon-size-8"></mat-icon>
        <span class="text-sm font-medium">No recent activity</span>
      </div>
    }
  </div>
</fuse-card>
